// import type { Breakpoints } from '@oneaudi/unified-web-common';

type Breakpoints<T> = { xs: T; m: T };

export type Video = {
  alt: string;
  aspectRatio?: string;
  autoPlay?: boolean;
  caption?: string;
  loop?: boolean;
  muted?: boolean;
  nativeControls?: boolean;
  poster?: string;
  src?: string;
  audioDescription?: string;
};

interface VideoProps extends Video {
  altPortrait: string;
  audioDescription: string | undefined;
  audioDescriptionPortrait: string | undefined;
  captionPortrait: string | undefined;
  videoUrlLargeScreen: string;
  videoUrlSmallScreen: string;
  isMobile: boolean;
  preserveVideoWidth: boolean;
}

export type VideoPlayerConfig = {
  videos: Partial<Breakpoints<Video>>;
  playsInline: boolean;
  cover?: boolean;
  isFormatable?: boolean;
};

export function getVideoPlayerConfig(props: VideoProps): VideoPlayerConfig {
  const {
    alt,
    altPortrait,
    audioDescription,
    audioDescriptionPortrait,
    autoPlay,
    caption,
    captionPortrait,
    loop,
    muted,
    videoUrlLargeScreen,
    videoUrlSmallScreen,
    isMobile,
    preserveVideoWidth,
  } = props;
  const parseContentToScreenSize = () => {
    if (isMobile) {
      return {
        alt: altPortrait,
        aspectRatio: '1/1',
        audioDescription: audioDescriptionPortrait,
        autoPlay,
        caption: captionPortrait,
        loop,
        muted,
        nativeControls: true,
        src: videoUrlSmallScreen,
      };
    }
    return {
      alt,
      aspectRatio: '16/9',
      audioDescription,
      autoPlay,
      caption,
      loop,
      muted,
      nativeControls: true,
      src: videoUrlLargeScreen,
    };
  };

  return {
    cover: !preserveVideoWidth,
    playsInline: true,
    videos: {
      xs: parseContentToScreenSize(),
    },
  };
}
